import { useSession } from './provider';

/** An image source that carries the bearer — what React Native's `Image` and expo-image accept. */
export interface AuthorizedImage {
  uri: string;
  headers: Record<string, string>;
}

/**
 * Core serves photos (profile images, handwriting pages) from `/api/download/file/…`, which
 * answers 403 without the person's bearer — a plain `{ uri }` renders as a blank circle.
 * Without a token there is nothing to show yet, so callers fall back to initials.
 */
export function authorizedImage(
  url: string | undefined,
  token: string | undefined,
): AuthorizedImage | undefined {
  if (!url || !token) return undefined;
  return { uri: url, headers: { Authorization: `Bearer ${token}` } };
}

/** The signed-in person's current access token, for `authorizedImage` inside lists. */
export function useAccessToken(): string | undefined {
  return useSession().tokens?.accessToken;
}

/** One photo from Core, ready for an `Image` — or undefined until it can be shown. */
export function useAuthorizedImage(url: string | undefined): AuthorizedImage | undefined {
  return authorizedImage(url, useAccessToken());
}
